document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
        if ($('#admin-order').length === 0) {
            return;
        }
        reload_cart();
        $(document).on('click', '.admin-product .btn', function (e) {
            e.preventDefault();
            var productRow = $(this).closest('.admin-product');

            var productId = $(productRow).data('id');
            var quantity = $(productRow).find('.qty').val() || 1;
            var variationId = $(productRow).find('.variation_id').val();
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'admin_order_add_product',
                    productId: productId,
                    quantity: quantity,
                    variationId: variationId
                },
                success: function (response) {
                    var $nearestQuantityInput = $(productRow).find('.qty');
                    $nearestQuantityInput.val(0);
                    reload_cart();
                }
            });
        });

        $(document).on('click', '.order-list__line .remove', function (e) {
            e.preventDefault();

            var $this = $(this);
            var cartItemKey = $this.closest('.order-list__line').data('cart-item-key');

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'admin_order_remove_cart_item',
                    cart_item_key: cartItemKey
                },
                success: function (response) {
                    reload_cart();
                }
            });
        });
        function reload_cart() {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'admin_order_get_cart'
                },
                beforeSend: function () {
                    $('#order-list').html('<div class="order-loading"></div>');
                },
                success: function (response) {
                    response = JSON.parse(response);
                    if (response.success == true) {
                        $('#order-list').html(response.cart);
                        $('#order-total').html(response.total);
                    }
                }
            });
        }
    });
});